import React, { useState } from 'react'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import media from '../../styles/media'
import ContactUsModal from '../popupModal/ContactUsModal';
import NextMarket from '../../component/NextMarket';
import StyledButton from '../../styles/StyledButton';




const SubFooter = () => {
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    return (
        <Container>
            <Styles>
                <NextMarket />
                <div>
                    <StyledButton className='purple--btn' as='a' onClick={handleShowModal} >Contact Us</StyledButton>
                    <ContactUsModal showModal={showModal} handleCloseModal={handleCloseModal} />
                </div>
            </Styles>
        </Container>
    )
}

const Styles = styled.div`
    padding: 50px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self: left;
    margin: 30px auto;

    &&& p {
        margin-bottom: 0;
    }


    .post-pageDesc {
        font-weight: 600;
        color: ${props => props.theme.cmPlum}
    }

    ${media.mobileS`
        padding: 25px 0;
        flex-direction: column;
        justify-content: center;
        margin: 0;

        &&& p {
            margin-bottom: 10px;
        }

        div {
            display: flex;
            text-align: center;
            flex-direction: column;
            justify-content: space-around;
        }

        .post-pageDesc {
            padding-bottom: 14px;
            width: 80%;
            margin: 0 auto;
        }
        
    `}

    ${media.tablet`
        padding: 25px 0;
        flex-direction: row;
        justify-content: space-between;

        div {
            text-align: left;
        }

        .post-pageDesc {
            padding-bottom: 0;
            width: 60%;
            margin: 0;
        }
    `}

    ${media.tabletL`
        padding: 50px 0;

        .post-pageDesc {
            width: 55%;
        }
    `}
`

export default SubFooter;